import type { TOC } from '@ember/component/template-only';

const NotFoundRouteTemplate: TOC<object> = <template>{{outlet}}</template>;

export default NotFoundRouteTemplate;
